import { api } from './api';
import { fetchResource, updateResource } from './fetchResource';

export function fetchContentPages() {
  return dispatch => fetchResource(dispatch, 'content_pages', 'CONTENT_PAGES_FETCHED');
}
